import { forwardRef } from "react";
import styles from "./Input.module.css";
import { InputProps } from "../../types/index";

function InnerInput<T extends string, U extends string>(
  { label, name, errorMessage, ...props }: InputProps<T, U>,
  ref: React.Ref<HTMLInputElement>
) {
  return (
    <div>
      {label && (
        <label htmlFor={name} className={styles.label}>
          {label}
        </label>
      )}

      <input
        {...props}
        className={styles.input}
        ref={ref}
        id={name}
        name={name}
      />

      {errorMessage && <p className={styles.error}>{errorMessage}</p>}
    </div>
  );
}

const Input = forwardRef(InnerInput) as <T extends string, U extends string>(
  props: InputProps<T, U> & { ref?: React.Ref<HTMLInputElement> }
) => ReturnType<typeof InnerInput>;

export default Input;
